import { SVGProps } from "react";

const MenuGridSmall = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="1" width="23" height="23" rx="3.5" stroke="currentColor" />
      <path
        d="M14 15.5C14 16.0523 14.4477 16.5 15 16.5C15.5523 16.5 16 16.0523 16 15.5C16 14.9477 15.5523 14.5 15 14.5C14.4477 14.5 14 14.9477 14 15.5Z"
        stroke="#00EC97"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 15.5C14 16.0523 14.4477 16.5 15 16.5C15.5523 16.5 16 16.0523 16 15.5C16 14.9477 15.5523 14.5 15 14.5C14.4477 14.5 14 14.9477 14 15.5Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.5C8 16.0523 8.44772 16.5 9 16.5C9.55228 16.5 10 16.0523 10 15.5C10 14.9477 9.55228 14.5 9 14.5C8.44772 14.5 8 14.9477 8 15.5Z"
        stroke="#00EC97"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.5C8 16.0523 8.44772 16.5 9 16.5C9.55228 16.5 10 16.0523 10 15.5C10 14.9477 9.55228 14.5 9 14.5C8.44772 14.5 8 14.9477 8 15.5Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.5C14 10.0523 14.4477 10.5 15 10.5C15.5523 10.5 16 10.0523 16 9.5C16 8.94772 15.5523 8.5 15 8.5C14.4477 8.5 14 8.94772 14 9.5Z"
        stroke="#00EC97"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.5C14 10.0523 14.4477 10.5 15 10.5C15.5523 10.5 16 10.0523 16 9.5C16 8.94772 15.5523 8.5 15 8.5C14.4477 8.5 14 8.94772 14 9.5Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.5C8 10.0523 8.44772 10.5 9 10.5C9.55228 10.5 10 10.0523 10 9.5C10 8.94772 9.55228 8.5 9 8.5C8.44772 8.5 8 8.94772 8 9.5Z"
        stroke="#00EC97"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.5C8 10.0523 8.44772 10.5 9 10.5C9.55228 10.5 10 10.0523 10 9.5C10 8.94772 9.55228 8.5 9 8.5C8.44772 8.5 8 8.94772 8 9.5Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MenuGridSmall;
